export enum PricerModes {
  interestRate = 1,
  fx = 2,
  inflation = 3,
  commodity = 4,
  custom = 5,
  debt = 6,
}
